exports.hasDateInput = require('../../src/js/client/hasDateInput').default;
